import { gateway } from "../../../../gateway";

export interface IMergeInvoiceWithScopePdfPayload {
  invoicePdfBase64: string;
  scopeOfWorkUrls: string[];
  token?: string | null;
}

export const mergeInvoiceWithScopePdf = async ({ invoicePdfBase64, scopeOfWorkUrls, token }: IMergeInvoiceWithScopePdfPayload): Promise<Blob> => {
  const response = await gateway.post(
    `/invoices/merge-with-scope`,
    {
      invoicePdfBase64,
      scopeOfWorkUrls,
    },
    {
      params: token ? { token } : undefined,
      responseType: "blob",
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : undefined,
    },
  );

  return response.data;
};
